import { PAGINATION_DEFAULT_PAGE_SIZE } from '@shared/utils';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HrtApiService } from '../hrt-api/hrt-api.service';
import {
  FaultCatalog,
  AnnunciationsMetaData,
  ResolvedFaultDTO,
  RecommendationDto,
  RecommendationStatus,
  CreateRecommendationFromResolvedFaultParams,
  FetchFaultCatalogParams,
  FetchResolvedFaultsParams,
} from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class FaultRecommendationsApiService {
  baseUrl = 'settings/catalog';

  readonly api = inject(HrtApiService);

  fetchFaultCatalog(params?: FetchFaultCatalogParams): Observable<FaultCatalog> {
    let queryParams = params?.type ? `?type=${params.type}` : '';

    if (params?.withoutRecommendations) {
      queryParams += `${params.type ? '&' : '?'}withoutRecommendations=${params.withoutRecommendations}`;
    }

    return this.api.get(`${this.baseUrl}/faults${queryParams}`);
  }

  fetchAnnunciationsMetadata(): Observable<AnnunciationsMetaData> {
    return this.api.get(`${this.baseUrl}/metadata`);
  }

  fetchResolvedFaults(params: FetchResolvedFaultsParams): Observable<ResolvedFaultDTO> {
    return this.api.get(
      `${this.baseUrl}/resolved-faults?page=${params.page}&pageSize=${params.pageSize ?? PAGINATION_DEFAULT_PAGE_SIZE}`
    );
  }

  createRecommendationFromResolvedFault({
    resolvedFault: { id, faultCode, images, additionalNote: actionName },
    reviewStatus,
  }: CreateRecommendationFromResolvedFaultParams): Observable<RecommendationDto> {
    return this.api.post(`${this.baseUrl}/create-recommendation`, {
      id,
      actionName,
      faultCode,
      images,
      reviewStatus,
      status: RecommendationStatus.PENDING,
    });
  }
}
